import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { resolveIntent, type SaIntent } from "./intent-map";

export const getSaIntent = createServerFn({ method: "GET" })
  .inputValidator((data: { q?: string } | undefined) => data ?? {})
  .handler(async ({ data }): Promise<SaIntent> => {
    let referer: string | null = null;
    try {
      const req = getRequest();
      referer = req.headers.get("referer") ?? req.headers.get("Referer") ?? null;
    } catch {
      referer = null;
    }
    return resolveIntent({ referer, q: data.q ?? null });
  });